import UniversalCookie from 'universal-cookie';

class Cookies extends UniversalCookie {
  setCredentials = ({
    token,
    tokenTTL,
    refreshToken,
    refreshTokenTTL,
  }: {
    token: string;
    tokenTTL: string;
    refreshToken: string;
    refreshTokenTTL: string;
  }) => {
    const expiresToken = new Date(tokenTTL);
    const expiresRefreshToken = new Date(refreshTokenTTL);
    this.set('token', token, { sameSite: true, expires: expiresToken, path: '/' });
    this.set('refreshToken', refreshToken, { sameSite: true, expires: expiresRefreshToken, path: '/' });
  };

  removeCredentials = () => {
    this.remove('token', { path: '/' });
    this.remove('refreshToken', { path: '/' });
  };
}

export const clientCookies = new Cookies();
